import React from "react";
import { InputBaseComponentProps, TextField } from "@material-ui/core";
import { FormErrors } from "./FormErrors";
import styled from "styled-components";

const StyledTextField = styled(TextField)<{ readonly?: boolean }>`
  & textarea {
    line-height: 25px;
  }

  ${props =>
    props.readonly &&
    `
  & .MuiInput-underline.Mui-disabled:before {
    border-bottom: none;
  }

  & .MuiInput-underline:before {
    border-bottom: none;
  }

  & .MuiInputBase-root.Mui-disabled {
    color: rgba(0, 0, 0, 0.87);
    cursor: default;
  }

  & .MuiFormLabel-asterisk {
    display: none;
  }
  `}
`;

export interface IFormTextFieldProps<K> {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  form: K;
  formErrors: FormErrors<K>;
  name: keyof K;
  label: string;
  required?: boolean;
  readonly?: boolean;
  multiline?: boolean;
  disabled?: boolean;
  inputProps?: InputBaseComponentProps;
}

function FormTextField<TForm>(props: IFormTextFieldProps<TForm>) {
  const { onChange: handleChange, form, formErrors, name, label, required, multiline, readonly, disabled, inputProps } = props;

  return (
    <StyledTextField
      error={formErrors[name]!.error}
      helperText={formErrors[name]!.message}
      required={required}
      name={name as string}
      value={form[name]}
      label={label}
      onChange={handleChange}
      fullWidth
      multiline={multiline}
      readonly={readonly}
      disabled={readonly || disabled}
      inputProps={inputProps}
      InputLabelProps={{ shrink: true }}
    />
  );
}

export default FormTextField;
